// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  ButtonBase,
  Chip,
  Drawer,
  Stack,
  Tooltip,
  useMediaQuery,
} from "@mui/material";

import PerfectScrollbar from "react-perfect-scrollbar";
import { useNavigate } from "react-router-dom";
import { BrowserView, MobileView } from "react-device-detect";

import { drawerWidth } from "../../store/constant";
import LogoSection from "../LogoSection/LogoSection";
import MenuList from "./MenuList/MenuList";
import LogoutNavItem from "./MenuList/NavItem/LogoutNavItem";
import { IconMenu2 } from "@tabler/icons-react";

import { useAuth } from "src/context/AuthContext";
import { GetAuthRole } from "src/hooks/useAuthRole";

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const { logout } = useAuth();
  const AuthRole = GetAuthRole();

  const handleLogout = async () => {
    logout();
    navigate("/auth/login");
  };

  const drawerWidthCollapsed = 60; // Icon-only width

  const drawer = (
    <Box
      className={`${drawerOpen?"drawerOpen": "drawerClosed"} side_bar_Style`}
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* Logo + Toggle */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: drawerOpen ? "space-between" : "center",
          p: 2,
        }}
      >
        {drawerOpen && (
          <Box>
            <LogoSection collapsed={!drawerOpen} />
          </Box>
        )}

        {/* {drawerOpen && ( */}
        <ButtonBase sx={{ borderRadius: "4px", overflow: "hidden" }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              "&:hover": {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light,
              },
            }}
            onClick={drawerToggle}
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
        {/* )} */}
      </Box>

      {/* Scrollable menu */}
      <Box sx={{ flexGrow: 1 }}>
        <BrowserView>
          <PerfectScrollbar
            component="div"
            style={{
              height: !matchUpMd ? "80vh":"80vh",
              // height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 88px)",
              paddingLeft: drawerOpen ? "16px" : "8px",
              paddingRight: drawerOpen ? "16px" : "8px",
            }}
          >
            <MenuList AuthRole={AuthRole} collapsed={!drawerOpen} />
            <LogoutNavItem logout={handleLogout} collapsed={!drawerOpen} />
          </PerfectScrollbar>
        </BrowserView>

        <MobileView>
          <Box sx={{ px: drawerOpen ? 2 : 1 }}>
            <MenuList AuthRole={AuthRole} collapsed={!drawerOpen} />
            <LogoutNavItem logout={handleLogout} collapsed={!drawerOpen} />
          </Box>
        </MobileView>
      </Box>

      {/* Version chip */}
      <Stack direction="row" justifyContent="center" sx={{ mb: 2 }}>
        <Tooltip title="App Version" arrow disableHoverListener={drawerOpen}>
          <Chip
            label={drawerOpen ? process.env.REACT_APP_VERSION : "v"}
            disabled
            size="small"
            sx={{ cursor: "pointer" }}
          />
        </Tooltip>
      </Stack>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { md: 0 },
        width: drawerOpen ? drawerWidth : drawerWidthCollapsed,
      }}
      aria-label="sidebar"
    >
      <Drawer
        container={container}
        variant={matchUpMd ? "permanent" : "temporary"}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerOpen ? drawerWidth : drawerWidthCollapsed,
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: "none",
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: "hidden",
            [theme.breakpoints.up("md")]: {
              top: "88px",
            },
          },
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default Sidebar;